require("core-js/features/promise");
import { ShowReadingEntryLink } from "../../../Areas/eServices/Scripts/Default/ShowReadingEntryLink";
import { ILoaderFactory } from "../../inpulse/Loaders/ILoader";
import { DefaultLoaderFactory} from "../../inpulse/Loaders/DefaultLoaderFactory";
import { DefaultValidationNotificator, IValidationNotificator } from "../../inpulse/Notificators/IValidationNotificator";
import { InternationalPhoneInput, InternationalPhoneInputInitializer, InternationalPhoneInputSettings, ValidationMessages } from "../../country/InternationalPhoneInput";
import { Countries } from "../../country/country";
declare var readingEntryApiUrl: string;
declare var window: Window;

declare interface Window {
    root: any;
    _lf: ILoaderFactory;
    _notificator: IValidationNotificator;
    InternationalPhoneInputValidationMessages: ValidationMessages;
}

//declare interface root {
//    countries: Countries;
//    InternationalPhoneInputSettings: InternationalPhoneInputSettings;
//    InternationalPhoneInputInitializer: InternationalPhoneInputInitializer;
//}

//console.log("test");
window._lf = new DefaultLoaderFactory();
window._notificator = new DefaultValidationNotificator();
window.root = { countries: Countries, InternationalPhoneInputSettings: InternationalPhoneInputSettings, InternationalPhoneInputInitializer: InternationalPhoneInputInitializer };
window.root.countries = new Countries();
if (window.InternationalPhoneInputValidationMessages === window['undefined'] || window.InternationalPhoneInputValidationMessages === null) {
    window.InternationalPhoneInputValidationMessages = new ValidationMessages();
}
window.root.InternationalPhoneInputSettings = new InternationalPhoneInputSettings(true, window.InternationalPhoneInputValidationMessages);
window.root.InternationalPhoneInputInitializer = new InternationalPhoneInputInitializer(document, window.root.InternationalPhoneInputSettings )

$(function () {
    //window.permissionModule = new ShowReadingEntryLink(readingEntryApiUrl, true);
   // window.permissionModule.Init();

});